const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWidgets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icono",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.97,
    width: 37.01,
    height: 37.01,
    rx: 7.53,
    ry: 7.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.02,
    width: 37.01,
    height: 37.01,
    rx: 7.53,
    ry: 7.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.99,
    y: 42.97,
    width: 37.01,
    height: 37.01,
    rx: 7.53,
    ry: 7.53,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.05,15.55h-9.58V5.97c0-1.64-1.33-2.97-2.97-2.97s-2.97,1.33-2.97,2.97v9.58h-9.58c-1.64,0-2.97,1.33-2.97,2.97s1.33,2.97,2.97,2.97h9.58v9.58c0,1.64,1.33,2.97,2.97,2.97s2.97-1.33,2.97-2.97v-9.58h9.58c1.64,0,2.97-1.33,2.97-2.97s-1.33-2.97-2.97-2.97Z",
    style: {
      fill: "#e0e0e0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgets);
export default __webpack_public_path__ + "static/media/widgets.797802ae70aedd2bdc901246f78431ef.svg";
export { ForwardRef as ReactComponent };